import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom"
import Videobook from "../components/Videobook";
import Audiobook from "../components/Audiobook";

export default function CourseDeepLink() {
  const { courseId } = useParams();
  const navigate = useNavigate();

  const [subject, setSubject] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_USER_API_URL}/subjects/by-course-id/${encodeURIComponent(courseId)}`,
          { method: "GET" }
        );

        if (!res.ok) {
          throw new Error(`Course not found (${res.status})`);
        }

        const json = await res.json();
        if (alive) setSubject(json);
      } catch (e) {
        if (alive) setError(e.message || "Failed to load course");
      }
    })();

    return () => {
      alive = false;
    };
  }, [courseId]);

  if (error) {
    return (
      <div className="p-10">
        <div className="text-xl font-semibold mb-2">Couldn’t open course</div>
        <div className="text-slate-600 mb-6">{error}</div>
        <button
          className="px-4 py-2 rounded-lg bg-slate-100 border border-slate-300"
          onClick={() => navigate("/")}
        >
          Back to Library
        </button>
      </div>
    );
  }

  if (!subject) return <div className="p-10">Loading…</div>;

  return subject.type === "Audiobook" ? (
    <Audiobook subject={subject} exerciseHandler={() => navigate("/")} />
  ) : (
    <Videobook subject={subject} exerciseHandler={() => navigate("/")} />
  );
}
